<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center">
                <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                    <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                        <IconContactSVG class="w-24 h-24"/>
                    </div>
                </div>

                <span class="ml-12 font-normal title-lg text-primary">{{ $t('info.contact_details') }}</span>
            </div>
            <div v-for="contact in filteredContacts" :key="contact.communication_device_id">
                <span class="mt-16 self-label">{{ $t(contactTranslationsMap[contact.name] || contact.name) }}</span>
                <span class="text-base font-semibold sm:text-md">{{ contact.value }}</span>
            </div>

            <span class="mt-16 self-label">{{ $t('info.language') }}</span>
            <span class="text-base font-semibold sm:text-md">{{ translatedLanguage }}</span>

            <span v-if="customerInfo.customertype === 'O' && customerInfo.website"
                  class="mt-16 self-label">{{ $t('info.website_address') }}</span>
            <span class="text-base font-semibold sm:text-md self-text-link"><a
                :href="formattedWebsite">{{ customerInfo.website }}</a></span>

            <button @click="updateCommDevices" v-if="customerInfo.customertype === 'P'"
                    data-open-modal="contactsPrivate" class="mt-16 self-btn-plain">
                <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                    <IconPencilSVG/>
                </span>
                <span class="self-btn-plain__text">{{ $t('info.modify') }}</span>
            </button>
        </div>
        <!--    CARD END-->

        <!--  PRIVATE CUSTOMER MODAL START  -->
        <div class="micromodal" id="contactsPrivate" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.edit_contact_details') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG/>
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <!--TODO: alert config-->
                        <!--                        <AlertSummary main-text="Veateate info siin"-->
                        <!--                                      secondary-text="Vormi salvestamisel esines viga. Palun kontrolli sisestatud andmeid."-->
                        <!--                                      alert-classes="e5-form-error-summary&#45;&#45;error"/>-->
                        <div class="flex self-form-wrap">
                            <div v-if="customerInfo.customertype === 'P'" class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="epost">{{ $t('signup.email') }} <span
                                    class="e5-form-field-required">({{ $t('info.required') }})</span><span
                                    class="e5-form-field-required">*</span></label>
                                <div class="flex items-center">
                                    <input type="text" id="epost" disabled placeholder="" name="epost" v-model="email"
                                           class="e5-input">
                                </div>
                            </div>

                            <div v-if="customerInfo.customertype === 'P'" class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="mobiil">{{ $t('info.mobile_phone') }}</label>
                                <div class="flex items-center">
                                    <input type="text" id="mobiil" placeholder="" name="mobiil" v-model="mobile"
                                           class="e5-input">
                                    <button @click="mobile=''" class="self-btn-primary-alert ml-10"
                                            style="white-space: nowrap;">
                                        {{ $t('info.delete') }}
                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconXSVG/>
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div v-if="customerInfo.customertype === 'P'" class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="telefon">{{ $t('info.phone') }}</label>
                                <div class="flex items-center">
                                    <input type="text" id="telefon" placeholder="" name="telefon" v-model="phone"
                                           class="e5-input">
                                    <button @click="phone=''" class="self-btn-primary-alert ml-10"
                                            style="white-space: nowrap;">
                                        {{ $t('info.delete') }}
                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconXSVG/>
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <!--                           class="e5-error" for red outline-->
                            <div v-if="customerInfo.customertype === 'P'" class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="suhtluskeel">{{ $t('info.language') }}</label>
                                <div class="relative">
                                    <input type="text" id="suhtluskeel" name="suhtluskeel"
                                           :value="translatedLanguage.toString()"
                                           class="e5-input" disabled>
                                </div>
                            </div>
                            <!--                            <div class="w-full self-form-wrap-item">-->
                            <!--                                <label class="e5-form-label" for="veeb">Veebilehe aadress</label>-->
                            <!--                                <div class="relative">-->
                            <!--                                    <input type="text" id="veeb" placeholder="" name="veeb" value="maailmaviljad.com"-->
                            <!--                                           class="e5-input">-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button @click="submitChanges" class="self-btn-primary">
                                        {{ $t('info.save') }}

                                        <span class="text-yellow-300 self-btn-primary__icon">
                      <IconArrowAltSVG/>
                    </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close class="self-btn-plain">
                      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                          <IconXSVG/>
                      </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!--  PRIVATE CUSTOMER MODAL END  -->
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import IconPencilSVG from '@/assets/static/icons-src/icon-pencil.svg'
import IconXSVG from '@/assets/static/icons-src/icon-x.svg'
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg'
import IconContactSVG from '@/assets/static/icons-src/icon-contact.svg'
import AlertSummary from '@/components/AlertSummary.vue'
import { ICustomer } from '@/domain/ICustomer'
import { IContacts } from '@/domain/IContacts'
import MicroModal from 'micromodal'
import { IDeleteCommunicationDeviceRequest, ISaveCommunicationDeviceRequest } from "@/domain/ISaveInfo"
import store from '@/store'
@Component({
    components: {
        AlertSummary,
        IconPencilSVG,
        IconXSVG,
        IconArrowAltSVG,
        IconContactSVG
    }
})
export default class ContactInformation extends Vue {
    contactTranslationsMap = {
        'Business Mobile Phone': 'info.business_mobile_phone',
        'Business Phone': 'info.business_phone',
        'Rpid mail': 'info.rpid_email',
        'Business E-mail': 'info.business_email',
        'E-mail': 'signup.email',
        Phone: 'info.phone',
        'Mobile Phone': 'info.mobile_phone'
    }

    get translatedLanguage() {
        // Uses the preferred_language value to find the appropriate translation
        return this.$t(`info.langs.${this.customerInfo.preferred_language}`);
    }

    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo
    }

    get filteredContacts(): IContacts[] {
        let contacts: IContacts[] = [];

        if (this.customerInfo.customertype === 'O') {
            // Filter and sort contacts for organization type 'O'
            contacts = this.customerInfo.contacts.filter(contact => {
                return (((contact.name === 'Business Mobile Phone' || contact.name === 'Business Phone') && (contact.reminding_allowed || contact.feedback_allowed)) || ((contact.name === 'Rpid mail' || contact.name === 'Business E-mail') && (contact.reminding_allowed || contact.mailing_allowed || contact.feedback_allowed || contact.billing_allowed)))
            });
        } else if (this.customerInfo.customertype === 'P') {
            // Filter and sort contacts for private type 'P'
            const email = this.customerInfo.contacts.find(contact => contact.name === 'E-mail');
            if (email) contacts.push(email);
            const phone = this.customerInfo.contacts.find(contact => contact.name === 'Phone');
            if (phone) contacts.push(phone);
            const mobile = this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone');
            if (mobile) contacts.push(mobile);
        }

        // Sort contacts alphabetically by contact.name
        contacts.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // ignore case
            const nameB = b.name.toUpperCase(); // ignore case
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        return contacts;
    }

    get formattedWebsite() {
        if (!/^https?:\/\//i.test(this.customerInfo.website)) {
            return 'http://' + this.customerInfo.website;
        } else return this.customerInfo.website
    }

    // Private customer modal fields for email, phone and mobilephone

    email = this.customerInfo.contacts.find(contact => contact.name === 'E-mail') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'E-mail').value : ''
    phone = this.customerInfo.contacts.find(contact => contact.name === 'Phone') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'Phone').value : ''
    mobile = this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone').value : ''

    /**
     * Update communication device field values from customerinfo if private customer modal is opened.
     */
    updateCommDevices() {
        this.email = this.customerInfo.contacts.find(contact => contact.name === 'E-mail') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'E-mail').value : ''
        this.phone = this.customerInfo.contacts.find(contact => contact.name === 'Phone') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'Phone').value : ''
        this.mobile = this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone').value : ''
    }

    /**
     * Confirm changes/deletions made in the contacts and send modification/deletion requests.
     */
    async submitChanges() {
        // Email changes
        const initialEmail = this.customerInfo.contacts.find(contact => contact.name === 'E-mail') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'E-mail') : undefined
        if (initialEmail) { // PUT and DELETE requests
            if (initialEmail.value !== this.email) { // Email has been changed and needs to be updated with a put request
                if (this.email === '') {
                    const request: IDeleteCommunicationDeviceRequest = {
                        customerId: this.customerInfo.customerid,
                        communicationDeviceId: initialEmail.communication_device_id
                    }
                    const success = await store.dispatch("deleteCommunicationDevice", request);
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                } else {
                    const request: ISaveCommunicationDeviceRequest = {
                        customerId: this.customerInfo.customerid,
                        type: initialEmail.type,
                        value: this.email,
                        communicationDeviceId: initialEmail.communication_device_id
                    }
                    const success = await store.dispatch("saveCommunicationDevice", request);
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                }
            }
        } else if (this.email !== '') { // POST request
            const request: ISaveCommunicationDeviceRequest = {
                customerId: this.customerInfo.customerid,
                type: 1,
                value: this.email,
                communicationDeviceId: ''
            }
            const success = await store.dispatch("saveCommunicationDevice", request);
            if (!success) {
                this.requestErrorFunction()
                return
            }
        }

        // Phone changes
        const initialPhone = this.customerInfo.contacts.find(contact => contact.name === 'Phone') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'Phone') : undefined
        if (initialPhone) { // PUT and DELETE requests
            if (initialPhone.value !== this.phone) {
                if (this.phone === '') {
                    const request: IDeleteCommunicationDeviceRequest = {
                        customerId: this.customerInfo.customerid,
                        communicationDeviceId: initialPhone.communication_device_id
                    }
                    const success = await store.dispatch("deleteCommunicationDevice", request);
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                } else {
                    const request: ISaveCommunicationDeviceRequest = {
                        customerId: this.customerInfo.customerid,
                        type: initialPhone.type,
                        value: this.phone,
                        communicationDeviceId: initialPhone.communication_device_id
                    }
                    const success = await store.dispatch("saveCommunicationDevice", request);
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                }
            }
        } else if (this.phone !== '') { // POST request
            const request: ISaveCommunicationDeviceRequest = {
                customerId: this.customerInfo.customerid,
                type: 3,
                value: this.phone,
                communicationDeviceId: ''
            }
            const success = await store.dispatch("saveCommunicationDevice", request);
            if (!success) {
                this.requestErrorFunction()
                return
            }
        }

        // Mobile phone changes
        const initialMobile = this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone') !== undefined ? this.customerInfo.contacts.find(contact => contact.name === 'Mobile Phone') : undefined
        if (initialMobile) { // PUT and DELETE requests
            if (initialMobile.value !== this.mobile) {
                if (this.mobile === '') {
                    const request: IDeleteCommunicationDeviceRequest = {
                        customerId: this.customerInfo.customerid,
                        communicationDeviceId: initialMobile.communication_device_id
                    }
                    const success = await store.dispatch("deleteCommunicationDevice", request);
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                } else {
                    const request: ISaveCommunicationDeviceRequest = {
                        customerId: this.customerInfo.customerid,
                        type: initialMobile.type,
                        value: this.mobile,
                        communicationDeviceId: initialMobile.communication_device_id
                    }
                    const success = await store.dispatch("saveCommunicationDevice", request);
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                }
            }
        } else if (this.mobile !== '') { // POST request
            const request: ISaveCommunicationDeviceRequest = {
                customerId: this.customerInfo.customerid,
                type: 2,
                value: this.mobile,
                communicationDeviceId: ''
            }
            const success = await store.dispatch("saveCommunicationDevice", request);
            if (!success) {
                this.requestErrorFunction()
                return
            }
        }
        MicroModal.close('contactsPrivate');
        await store.dispatch("updateCustomerInfo");
    }

    private requestErrorFunction() {
        Vue.notify({
            group: 'api',
            title: 'Server error',
            text: 'Error while while modifying the contact information',
            type: 'warn'
        });
        MicroModal.close('contactsPrivate');
    }
}
</script>

<style scoped>

</style>
